import React from "react";
import { T } from "../theme";
import RetainerCard from "./RetainerCard";
import MonthlyLedger from "./MonthlyLedger";
import UpcomingCard from "./UpcomingCard";
import RateCardCard from "./RateCardCard";
import SessionBlock from "./SessionBlock";
import Banner from "../components/Banner";
import ExtrasCard from "./ExtrasCard";
import { toInvoiceSummary } from "./calc";
import { fmtMoney } from "./money";

// The Finance tab — composes whichever engagement modules the client's
// Finance Config declares (see the engagement-modules skill). No branching
// on client name or engagement type anywhere: declared modules only.
// A client declaring no finance modules gets the clean empty state.
export default function FinanceTab(props) {
  const { cfg, finance, upcoming, currentMonth } = props;
  const m = cfg.modules || {};
  // validateConfig() findings: shown, never fixed here (read-only).
  const problems = props.configProblems || [];
  const problemsBanner = problems.length > 0 && (
    <Banner tone="warn" message="Finance Config has problems, so some figures below may be wrong. Contact Thread if anything looks off.">
      <ul style={{ margin: "6px 0 0", paddingLeft: 18, fontSize: 12, color: T.fgSecondary }}>{problems.map(p => <li key={p}>{p}</li>)}</ul>
    </Banner>
  );

  if (Object.keys(m).length === 0) {
    return (
      <>
        {problemsBanner}
        <div style={{ background: T.canvas, borderRadius: T.radiusMd, border: `1px solid ${T.borderSubtle}`, padding: "40px 28px", textAlign: "center", boxShadow: T.shadowSm }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: T.root, marginBottom: 8 }}>Finance tracking not yet set up</h3>
          <p style={{ fontSize: 13, color: T.fgMuted, lineHeight: 1.6 }}>The finance configuration for this client needs to be added to Airtable. Add a "Finance Config" field to the client record with the engagement deal structure.</p>
        </div>
      </>
    );
  }

  const showLedger = !!(m.recurringSessions || m.rateCard || m.drawdownPool);
  const extras = props.extras || [];
  const open = toInvoiceSummary(finance, extras);

  return (
    <>
      {problemsBanner}
      {open.count > 0 && (
        <div style={{ marginBottom: 16, padding: "10px 16px", background: T.statusRiskBg, border: `1px solid ${T.statusRisk}30`, borderRadius: T.radiusMd, display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 12, fontSize: 12, color: T.statusRisk }}>
          <span><strong>Still to invoice</strong> · {open.count} item{open.count === 1 ? "" : "s"} billed separately</span>
          <strong style={{ fontSize: 14 }}>{fmtMoney(open.total)}</strong>
        </div>
      )}
      {m.sessionBlock && (
        <SessionBlock
          block={m.sessionBlock} sessions={props.blockSessions} history={props.blockHistory}
          onSetStatus={props.setBlockSessionStatus} onSetDate={props.setBlockSessionDate} onAdd={props.addBlockSession} onDelete={props.deleteBlockSession}
        />
      )}
      {m.retainer && <RetainerCard retainer={m.retainer} drawdownPool={m.drawdownPool} cfg={cfg} />}
      {showLedger && (
        <MonthlyLedger
          cfg={cfg} finance={finance} currentMonth={currentMonth}
          expandedMonth={props.expandedMonth} setExpandedMonth={props.setExpandedMonth}
          toggleCoaching={props.toggleCoaching}
          addingLineItem={props.addingLineItem} setAddingLineItem={props.setAddingLineItem}
          newLineItem={props.newLineItem} setNewLineItem={props.setNewLineItem}
          addFinanceLineItem={props.addFinanceLineItem} deleteLineItem={props.deleteLineItem} updateLineItem={props.updateLineItem} moveLineItem={props.moveLineItem}
          setCoachingDate={props.setCoachingDate} addCoachingSession={props.addCoachingSession} deleteCoachingSession={props.deleteCoachingSession}
        />
      )}
      {m.drawdownPool && (
        <UpcomingCard
          upcoming={upcoming}
          addingUpcoming={props.addingUpcoming} setAddingUpcoming={props.setAddingUpcoming}
          newUpcoming={props.newUpcoming} setNewUpcoming={props.setNewUpcoming}
          addUpcomingItem={props.addUpcomingItem} deleteUpcomingItem={props.deleteUpcomingItem} updateUpcomingItem={props.updateUpcomingItem}
        />
      )}
      {!showLedger && m.sessionBlock && (
        <ExtrasCard extras={extras} onAdd={props.addExtra} onUpdate={props.updateExtra} onDelete={props.deleteExtra} />
      )}
      {m.rateCard && <RateCardCard rates={m.rateCard.rates} />}
    </>
  );
}
